<template>
  <div class="lease-auth-image" :style="wrapStyle">
    <img
      v-if="displayUrl"
      :src="displayUrl"
      :style="{ objectFit: fit }"
      class="lease-auth-image__img"
      @error="onImgError"
      @click="onPreview"
    />
    <div v-else-if="loading" class="lease-auth-image__state">加载中...</div>
    <div v-else class="lease-auth-image__state">{{ errorText || "加载失败" }}</div>
  </div>
</template>

<script>
import {
  loadLeaseResourceObjectUrl,
  resolveLeaseResourceUrl
} from "@/service/fishPondLease.js";

export default {
  name: "LeaseAuthImage",
  props: {
    src: { type: String, default: "" },
    fit: { type: String, default: "cover" },
    width: { type: [Number, String], default: "" },
    height: { type: [Number, String], default: "" },
    previewList: { type: Array, default: null },
    previewIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      displayUrl: "",
      loading: false,
      errorText: "",
      ownedUrls: [],
      loadToken: 0
    };
  },
  computed: {
    wrapStyle() {
      var style = {};
      if (this.width !== "" && this.width != null) {
        style.width =
          typeof this.width === "number" ? this.width + "px" : this.width;
      }
      if (this.height !== "" && this.height != null) {
        style.height =
          typeof this.height === "number" ? this.height + "px" : this.height;
      }
      return style;
    }
  },
  watch: {
    src: {
      immediate: true,
      handler() {
        this.reload();
      }
    }
  },
  beforeDestroy() {
    this.revokeOwned();
  },
  methods: {
    revokeOwned() {
      (this.ownedUrls || []).forEach(function(u) {
        try {
          URL.revokeObjectURL(u);
        } catch (e) {}
      });
      this.ownedUrls = [];
    },
    remember(url) {
      if (url && String(url).indexOf("blob:") === 0) {
        this.ownedUrls.push(url);
      }
      return url;
    },
    reload() {
      var self = this;
      var token = ++this.loadToken;
      this.revokeOwned();
      this.displayUrl = "";
      this.errorText = "";
      if (!this.src) return;
      this.loading = true;
      loadLeaseResourceObjectUrl(this.src)
        .then(function(url) {
          if (token !== self.loadToken) {
            if (url && String(url).indexOf("blob:") === 0) {
              try {
                URL.revokeObjectURL(url);
              } catch (e) {}
            }
            return;
          }
          self.displayUrl = self.remember(url);
        })
        .catch(function() {
          if (token !== self.loadToken) return;
          // 回退：拼接完整 Resource 地址（部分环境可直接访问）
          var fallback = resolveLeaseResourceUrl(self.src);
          if (fallback && fallback !== self.src) {
            self.displayUrl = fallback;
            return;
          }
          self.errorText = "加载失败";
          self.displayUrl = "";
        })
        .then(function() {
          if (token !== self.loadToken) return;
          self.loading = false;
        });
    },
    onImgError() {
      // blob 失败后再试一次完整 URL；已是完整 URL 则标失败
      if (this.displayUrl && String(this.displayUrl).indexOf("blob:") === 0) {
        this.revokeOwned();
        var fallback = resolveLeaseResourceUrl(this.src);
        if (fallback) {
          this.displayUrl = fallback;
          return;
        }
      }
      this.displayUrl = "";
      this.errorText = "加载失败";
    },
    onPreview() {
      if (!this.displayUrl) return;
      window.open(this.displayUrl, "_blank");
    }
  }
};
</script>

<style scoped>
.lease-auth-image {
  width: 100%;
  height: 100%;
  background: #fafafa;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
}
.lease-auth-image__img {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
}
.lease-auth-image__state {
  width: 100%;
  height: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 12px;
  background: #f5f7fa;
}
</style>
